export const formateDateTime = (date) => {
  if (date === null) return "";
  return `${date["$y"]}-${date["$M"] + 1}-${date["$D"]} ${date["$H"]}:${
    date["$m"]
  }:${date["$s"]}`;
};
